@if (show()) {
    <div class="client-on-stop-warning">
        <mat-icon class="warning-icon" [matTooltip]="tooltipText() || ''" [matTooltipDisabled]="!tooltipText()"
            >warning</mat-icon
        >
        <span class="warning-text">{{ label() }}</span>
    </div>
}